import { connect } from 'react-redux'
import { createSelector } from 'reselect'

import { selectAccountPreferenceCustomerRatingsInstalled } from 'selectors/app/base'
import {
  agentNameByAgentGauge,
  happinessScoreRatioByAgentGauge,
  averageFirstResponseTimeByAgentGauge,
  averageResolutionTimeByAgentGauge,
  totalConversationsAssignedByAgentGauge,
  totalConversationsResolvedByAgentGauge,
} from 'ducks/reports/gauges'
import { TableV2Visualization } from 'ducks/reports/visualizations'

const selectProps = createSelector(
  selectAccountPreferenceCustomerRatingsInstalled,
  accountPreferenceCustomerRatingsInstalled => {
    const gauges = [
      {
        ...agentNameByAgentGauge,
        title: app.t('Agent'),
        scale: { y: 'agent' },
      },
      { ...totalConversationsAssignedByAgentGauge, title: 'Conversations' },
      { ...totalConversationsResolvedByAgentGauge, title: 'Resolutions' },
      {
        ...averageFirstResponseTimeByAgentGauge,
        title: '$Avg. Response Time',
      },
      {
        ...averageResolutionTimeByAgentGauge,
        title: '$Avg. Resolution Time',
      },
    ]
    if (accountPreferenceCustomerRatingsInstalled)
      gauges.push({ ...happinessScoreRatioByAgentGauge, title: 'CSAT Score' })
    return {
      accountPreferenceCustomerRatingsInstalled,
      join: {
        through: 'agent_name_by_agent',
      },
      gauges,
      sort: {
        by: accountPreferenceCustomerRatingsInstalled
          ? 'happiness_by_agent'
          : 'avg_resolution_time_by_agent',
      },
      title: `${app.t('Team')} Leaderboard`,
      pagination: { perPage: 10 },
    }
  }
)

export default connect(selectProps)(TeamLeaderBoardTable)

function TeamLeaderBoardTable(props) {
  return <TableV2Visualization {...props} />
}
